<template>
  <a-spin :spinning="confirmLoading">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form @submit="handleSubmit" :form="form">
        <a-form-item
          v-show="false"
          label="id"
        >
          <a-input
            v-decorator="['id']"
          />
        </a-form-item>
        <a-form-item
          v-show="false"
          label="projectId"
        >
          <a-input
            v-decorator="['projectId']"
          />
        </a-form-item>
        <a-form-item
          label="路段名称"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input
            :disabled="showable"
            v-decorator="[
              'projectName',
              {rules: [{ required: true, message: '请输入路段名称' }]}
            ]"
            placeholder="请输入路段名称" />
        </a-form-item>
        <a-form-item
          label="所属区域"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input
            :disabled="showable"
            v-decorator="[
              'region',
              {rules: [{ required: true, message: '请输入所属区域' }]}
            ]"
            placeholder="请输入所属区域" />
        </a-form-item>
        <a-form-item
          label="地址（道路起止点）"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input
            :disabled="showable"
            placeholder="请输入地址（道路起止点）"
            v-decorator="[
              'address',
              {rules: [{ required: true, message: '请输入地址（道路起止点）' }]}
            ]" />
        </a-form-item>
        <a-form-item
          label="绿地面积（平方米）"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input-number
            style="width: 100%"
            :disabled="showable"
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
              'greenArea',
            ]"
            placeholder="请输入绿地面积（平方米）" />
        </a-form-item>
        <a-form-item
          label="其中草坪面积（平方米）"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input-number
            style="width: 100%"
            :disabled="showable"
            placeholder="请输入草坪面积（平方米）"
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
              'lawnArea',
            ]" />
        </a-form-item>
        <a-form-item
          label="其中地被面积（平方米）"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input-number
            style="width: 100%"
            :disabled="showable"
            placeholder="请输入地被面积（平方米）"
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
              'coverArea',
            ]" />
        </a-form-item>
        <a-form-item
          label="道路长度（米）"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input-number
            style="width: 100%"
            :disabled="showable"
            placeholder="请输入道路长度（米）"
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
              'roadLength',
            ]" />
        </a-form-item>
        <a-form-item
          label="道路宽度（米）"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input-number
            style="width: 100%"
            :disabled="showable"
            placeholder="请输入道路宽度（米）"
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
              'roadWidth',
            ]" />
        </a-form-item>
        <a-form-item
          label="负责人"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input
            :disabled="showable"
            placeholder="请输入负责人"
            v-decorator="[
              'chargePerson',
            ]" />
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-textarea
            :disabled="showable"
            rows="4"
            placeholder="请输入"
            v-decorator="[
              'remark',
            ]" />
        </a-form-item>
        <a-form-item
          :wrapperCol="{ span: 24 }"
          style="text-align: center"
        >
          <a-button :loading="confirmLoading" :disabled="showable" htmlType="submit" type="primary" @click="handleOk">提交</a-button>
          <a-button key="cancel" @click="handleCancel" style="margin-left: 8px">返回</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-spin>
</template>

<script>

import { getObj, addObj, putObj } from '@/api/project/ProjectCuringInfo'
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'

export default {
  name: 'ProjectCuringInfoAddOrUpdate',
  mixins: [FormMixin],
  // mixins: [mixin, mixinDevice],
  data () {
    return {
      description: '创建管理一个养护工程',
      confirmLoading: false,
      addable: false,
      visible: false,
      editable: false,
      showable: false,
      managerList: [],

      // form
      form: this.$form.createForm(this),
      type: 'add',
      curingId: ''

    }
  },
  // watch: {
  //   '$route' (to, from) {
  //     // 强制刷新当前页面
  //     this.$router.go(0)
  //   }
  // },
  activated  () {
    this.curingId = this.$route.query.curingId
    this.type = this.$route.query.type
    this.edit(this.curingId, this.type)
  },
  methods: {
    // 获取信息
    edit (id, type) {
      this.visible = true
      if (type && type === 'add') {
        this.addable = true
        this.showable = false
        this.type = type
      }
      if (type === 'edit') {
        this.editable = true
        this.showable = false
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record.projectInfo, [
              'projectName'
            ]))
            setFieldsValue(pick(record.projectCuringInfo, [
              'id',
              'projectId',
              'region',
              'address',
              'greenArea',
              'lawnArea',
              'coverArea',
              'roadLength',
              'roadWidth',
              'chargePerson',
              'remark'
            ]))
          })
        })
      } else {
        resetFields()
      }
    },

    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          const postData = {}
          postData.projectInfo = {
            id: values.projectId,
            projectName: values.projectName
          }
          postData.projectCuringInfo = values
          try {
            if (this.type === 'edit') {
              this.confirmLoading = true
              await putObj(postData).then((res) => {
                this.confirmLoading = false
                this.$message.success('修改成功', 1).then(() => {
                  this.$router.push({ name: 'projectCuringInfo' })
                })
              })
            } else {
              await addObj(postData).then((res) => {
                this.confirmLoading = false
                this.$message.success('保存成功', 1).then(() => {
                  this.$router.push({ name: 'projectCuringInfo' })
                })
              })
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.visible = false
            }, 1500)
          } catch (e) {
            this.$message.error(e.msg)
            this.confirmLoading = false
          }
        }
      })
    },
    handleCancel () {
      this.$router.push({ name: 'projectCuringInfo' })
    },
    // handler
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-console
          // console.log('Received values of form: ', values)
        }
      })
    }
  }
}
</script>
